import React, { useState, useEffect } from 'react';
import translate from "./../../../lib/translate/TranslateJs";
import { getFEWalletParams } from "./../../../../platform.pay.config";

export function PendingWithdraw(pendingWithdraw) {
    return <div>
        <p className="pendingWithdrawBoxText">{translate("请耐心等待，您有一项提款申请正在处理中。")()}</p>
        <div className="pendingWithdrawBox">
            {
                Array.isArray(pendingWithdraw) && pendingWithdraw.length > 0 && pendingWithdraw.map((v, i) => {
                    return <p key={i} className="pendingWithdrawBoxText">{v.key} {v.value}</p>
                })
            }
        </div>
        <p className="pendingWithdrawBoxText">{translate("请等待处理完毕后，再提交其他提款申请。")()}</p>
    </div>
}


export function ThresholdWithdraw() {
    return <div>
        <p className="pendingWithdrawBoxText">{translate("我们注意到您的帐户中存在一些异常活动。请联系在线客服获取帮助。")()}</p>
        <p className="pendingWithdrawBoxText1"
            onClick={() => {
                getFEWalletParams()?.modalTip?.close()
                getFEWalletParams()?.goRecord()
            }}>{translate("提款记录")()}</p>
        <p className="pendingWithdrawBoxText2">{translate("了解如何设置银行账户限额")()}</p>
    </div>
}


export function ChargeNoticeWithdraw(props) {
    const [isCheck, setIsCheckVisible] = useState(false);
    return <div  className="usdt-exchange-hint">
        <h3 className="title">{translate("加密货币提款费用")()}</h3>
        <div className="content">
            <p className="desc">{translate("从2021/09/22起，当您提现加密货币时，若超过您的加密货币存款总额将会征收手续费。")()}</p>
            <p className="desc">{translate("您的加密货币余额将根据存款总额减去已提现总额进行计算。")()}</p>
            <div
                className="check-wrap"
                onClick={() => {
                    setIsCheckVisible(!isCheck)
                    props.getCheckBoxValue(!isCheck)
                }}>
                {
                    isCheck
                        ?
                        <div className="checked"></div>
                        :
                        <div className="check"></div>
                }
                <h4>{translate("不再提示")()}</h4>
            </div>
        </div>
    </div>
}

export function PhoneEmailVerification({ status = {} } = {}) {
    let { emailStatus, phoneStatus } = status
    return <div>
        <p style={{textAlign: 'left'}}>{translate('为了您的账户安全，请先完成以下验证：')()} : </p>
        {
            !emailStatus && !phoneStatus ? <ul className="numberList">
                <li className="">{translate('验证电子邮箱')()}</li>
                <li className="">{translate('验证手机号')()}</li>
            </ul> :
            !emailStatus ? <ul className="circleList">
                <li className="">{translate('验证电子邮箱')()}</li>
            </ul> :
            !phoneStatus ? <ul className="circleList">
                <li className="">{translate('验证手机号')()}</li>
            </ul> :
            null
        }
    </div>
}

export function WithdrawKycModal({ children, code, accountHolderName, firstName }) {
    return <div className='WithdrawKyc'>
        <p className='WithdrawKycIcon'></p>
        <p className='WithdrawKycMsg'>{children}</p>

        {
            code == 'SNC0001' && <>
                <p className='WithdrawKycMsg'>{translate('提款账户持有人姓名:')()} {accountHolderName}</p>
                <p className='WithdrawKycMsg'>{translate('已验证真实姓名:')()} {firstName}</p>
            </>
        }
    </div>
}


export function GlobalStorage() {
    return {
        load: async (value) => {
            let data = localStorage.getItem(value)
            // await global.storage.load({
            //     key: value,
            //     id: value,
            // }).then(res => {
            //     data = res
            // }).catch(err => {
            //     data = ''
            // })
            return data
        },
        save: (value) => {
            return localStorage.setItem(value, value)
            // return global.storage.save({
            //     key: value,
            //     id: value,
            //     data: value,
            //     expires: null,
            // })
        }
    }
}